document.addEventListener('rebuy.ready', function(event) {
    console.log('rebuy ready', event);
    const widgetProducts = event.detail.widget.data.products;
    getWidgetUpsellData(widgetProducts);
});

const getWidgetUpsellData = (widgetProducts) => {
    if(!widgetProducts?.length) return;
    
    widgetProducts.forEach(product => {
        const id = product.id;
        const preOrderValue = product.metafields?.custom?.pre_order;
        
        if(preOrderValue !== undefined) {
        const productOnWidget = document.querySelector(`div[data-rebuy-id="179859"] .rebuy-product-block.product-id-${id} .rebuy-product-actions button`);
        if(productOnWidget) {
            productOnWidget.innerHTML = '<span>Pre-order</span>';
        }
        }
    });
}